<template>
  <div>
    <div class="card-header pl-0">
      <div class="d-flex justify-content-between align-items-center">
        <div class="dropdown mr-3 d-none">
          <ul class="dropdown-menu" aria-labelledby="inspectorDropdown">
            <li><span class="dropdown-item" @click="activeComponent = 'main'">Main</span></li>
          </ul>
        </div>
        <span class="ml-3"><img class="heading-icon mr-2" src="~@/assets/device_hub_icon.svg"/> Inspector</span>
        <span class="text-primary ml-3">
          {{ $parent.activeComponentTitle }}
        </span>
        <div class="btn-menu-wrapper navbar navbar-expand-lg">
          <ul class="navbar-nav">
            <li class="nav-item">
              <span class="nav-link"
                    @click="activeComponent = 'main'"
                    :class="{'active':activeComponent == 'main'}">
                Main
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="inspector-wrapper">
          <div class="row">
            <div class="col-9">
              <maininspector v-if="activeComponent == 'main'"></maininspector>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

import maininspector from '../inspector-components/media-sounds/maininspector'
import $ from 'jquery'

export default {
  name: 'soundInspector',
  data () {
    return {
      activeComponent: 'main',
    }
  },
  components: {
    maininspector
  }
}
</script>




// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-wrap/soundInspector.vue